<div class="screen screen--detail">

  <header class="detail__hero ga-photo ga-photo--<%= p.photo %>">
    <% if ( p.images.length > 0 ) { %>
      <!-- The header image is the first of the list; tapping it opens the
           fullscreen viewer at that image (see core/Gallery.js). -->
      <button class="detail__hero-photo" type="button" data-gallery="0" aria-label="<%= _lcs( 'Bild vergrößern' ) %>">
        <img class="detail__hero-img" src="<%= p.images[ 0 ].url %>" alt="<%= p.images[ 0 ].alt %>" />
      </button>
      <% if ( p.images.length > 1 ) { %>
        <span class="detail__hero-count"><i class="icon icon--image"></i> <%= p.images.length %></span>
      <% } %>
    <% } else { %>
    <i class="icon icon--<%= p.icon %> detail__hero-glyph"></i>
    <% } %>
    <div class="detail__hero-scrim"></div>
    <button class="detail__round" type="button" data-id="back" aria-label="<%= _lcs( 'Zurück' ) %>"><i class="icon icon--arrow-left"></i></button>
    <button class="detail__round detail__round--right" type="button" data-id="share" aria-label="<%= _lcs( 'Teilen' ) %>"><i class="icon icon--share-2"></i></button>
  </header>

  <div class="detail__body">
    <div class="detail__badges">
      <span class="badge badge--accent"><%= p.cat %></span>
      <% if ( p.distance ) { %><span class="badge badge--sky"><%= p.distance %></span><% } %>
    </div>
    <h1 class="detail__title detail__title--lg"><%= p.title %></h1>
    <% if ( p.subtitle ) { %><p class="detail__sub"><%= p.subtitle %></p><% } %>

    <% if ( p.facts.length > 0 ) { %>
    <div class="factrow">
      <% p.facts.forEach( function( f ) { %>
        <span class="factrow__item"><i class="icon icon--<%= f.icon %>"></i> <%= f.text %></span>
      <% } ); %>
    </div>
    <% } %>

    <% if ( p.description ) { %>
    <p class="detail__text"><%= p.description %></p>
    <% } %>

    <!-- The route / the spot on a real basemap. Hidden until it renders, so
         the controls disappear with it when there is no map. -->
    <figure class="detail__map" data-id="map" hidden>
      <div class="detail__map-canvas" data-id="map-canvas"></div>

      <!-- Same controls as the Region tab's map (see core/MapView.bindControls):
           the wheel deliberately does not zoom, so these are how a guest on a
           desktop gets closer at all. -->
      <div class="mapctl mapctl--inset">
        <button class="mapctl__btn" type="button" data-map="in" aria-label="<%= _lcs( 'Vergrößern' ) %>"><i class="icon icon--plus"></i></button>
        <button class="mapctl__btn" type="button" data-map="out" aria-label="<%= _lcs( 'Verkleinern' ) %>"><i class="icon icon--minus"></i></button>
        <button class="mapctl__btn" type="button" data-map="reset" aria-label="<%= _lcs( 'Alles zeigen' ) %>"><i class="icon icon--locate-fixed"></i></button>
      </div>
    </figure>
    <p class="detail__map-hint" data-id="map-hint" hidden></p>

    <% if ( p.canKeepAwake ) { %>
    <button class="detail__wake" type="button" data-id="wake" aria-pressed="false">
      <i class="icon icon--sun"></i>
      <span class="detail__wake-text"><%= _lcs( 'Bildschirm anlassen, solange du der Tour folgst' ) %></span>
      <span class="detail__wake-state" data-id="wake-state"><%= _lcs( 'Aus' ) %></span>
    </button>
    <% } %>

    <% if ( p.hours.length > 0 ) { %>
    <div class="section-head section-head--tight"><h3><%= _lcs( 'Öffnungszeiten' ) %></h3></div>
    <dl class="hours">
      <% p.hours.forEach( function( d ) { %>
        <div class="hours__row<%= d.isToday ? ' hours__row--today' : '' %>">
          <dt><%= d.label %></dt>
          <dd><%= d.hours || _lcs( "geschlossen" ) %></dd>
        </div>
      <% } ); %>
    </dl>
    <% } %>

    <% if ( p.openingNote ) { %>
    <p class="detail__note"><i class="icon icon--info"></i> <%= p.openingNote %></p>
    <% } %>

    <% if ( p.address ) { %>
    <div class="locationcard">
      <div class="locationcard__row">
        <i class="icon icon--map-pin"></i>
        <span><%= p.address %></span>
      </div>
    </div>
    <% } %>

    <% p.links.forEach( function( l ) { %>
      <a class="btn btn--secondary btn--lg btn--block detail__link" href="<%= l.url %>"<% if ( l.external ) { %> target="_blank" rel="noopener noreferrer"<% } %>>
        <i class="icon icon--<%= l.icon %>"></i> <%= l.label %>
      </a>
    <% } ); %>

    <% if ( p.images.length > 1 ) { %>
    <div class="section-head section-head--tight"><h3><%= _lcs( 'Bilder' ) %></h3></div>
    <div class="rail rail--photos" data-id="photos">
      <!-- Index + 1: the hero above already shows image 0. -->
      <% p.images.slice( 1 ).forEach( function( img, i ) { %>
        <figure class="photocard">
          <button class="photocard__btn" type="button" data-gallery="<%= i + 1 %>"
                  aria-label="<%= _lcs( 'Bild {i} von {total} vergrößern', { i: i + 2, total: p.images.length } ) %>">
            <img src="<%= img.url %>" alt="<%= img.alt %>" loading="lazy" />
          </button>
          <% if ( img.credit ) { %><figcaption><%= img.credit %></figcaption><% } %>
        </figure>
      <% } ); %>
    </div>
    <% } %>

    <button class="btn btn--primary btn--lg btn--block detail__add" type="button" data-id="add">
      <i class="icon icon--calendar-plus"></i> <%= _lcs( 'Zum Planer hinzufügen' ) %>
    </button>

    <% if ( p.hasRoute ) { %>
    <button class="btn btn--secondary btn--lg btn--block detail__link" type="button" data-id="route">
      <i class="icon icon--navigation"></i> <%= _lcs( 'Route starten' ) %>
    </button>
    <% } %>

  </div>

</div>
